import Config from '../Config';
import { RestService } from './RestService';

export const ProjectService = {
    getProjectList: async function(start, numberItems, filter, statuses, sort, direction){
        return RestService.get(`${Config.get_projects_url}from=${start}&offset=${numberItems}&statuses=${statuses}&filter=${filter}&sort=${sort}&direction=${direction}`, {})
        .then(response => response.json());
    },
    createproject: async function(headers, body){
        return RestService.post(`${Config.create_project}`, headers, body);
        // .then(response => response.json());
    },
    getProjectNames: async function(){
        return RestService.get(`${Config.get_project_names}`, {})
        .then(response => response.json());
    },
    getTotalCount: async function(breakupBasedOnStatus) {
        return RestService.get(`${Config.total_count}data_type=PROJECT&breakup=${breakupBasedOnStatus}`, {})
        .then(response => response.json());
    },
    removeProject: async function(id) {
        return RestService.post(`${Config.remove_project}id=${id}`, {})
        .then(response => response.json());
    },
    changeProjectStatus: async function(headers, body){
        return RestService.post(`${Config.change_project_status}`, headers, body);
        // .then(response => response.json());
    },
    getProjectInfo: async function(id){
        return RestService.get(`${Config.get_project_info}id=${id}`, {})
        .then(response => response.json());
    }
};